import type { FunctionComponent } from 'react';

interface Props {
	points: number;
}

const PointsValue: FunctionComponent<Props> = (props: Props) => {
	const { points } = props;

	return <span>{points >= 0 ? '+' + points : points}</span>;
};

export default PointsValue;
